import { render, staticRenderFns } from "./BravoModule.vue?vue&type=template&id=5febdfd4&"
import script from "./BravoModule.vue?vue&type=script&lang=js&"
export * from "./BravoModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports